import ImageIcon from '@mui/icons-material/ImageOutlined';
import { Box, Typography, styled } from '@mui/material';

const THUMBNAIL_SIZE = 32;
const VALUE_COLUMN_WIDTH = 72;

export const PreviewLayout = styled(Box)(({ theme }) => ({
  display: 'flex',
  flex: 1,
  width: '100%',
  gap: theme.spacing(4),
  alignItems: 'flex-start',
}));

export const CreativesColumn = styled(Box)({
  flex: 1,
  minWidth: 0,
});

export const TemplatesColumn = styled(Box)({
  flex: 2,
  minWidth: 0,
});

export const ColumnStack = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(1.5),
}));

export const PreviewCard = styled(Box)(({ theme }) => ({
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: theme.shape.borderRadius * 1.5,
  padding: theme.spacing(2),
}));

export const ValueColumn = styled(Typography)({
  width: VALUE_COLUMN_WIDTH,
  flexShrink: 0,
  textAlign: 'left',
});

export const ThumbnailPlaceholder = styled(Box)(({ theme }) => ({
  width: THUMBNAIL_SIZE,
  height: THUMBNAIL_SIZE,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  backgroundColor: theme.palette.grey[100],
  borderRadius: theme.shape.borderRadius,
  flexShrink: 0,
}));

export const ThumbnailImage = styled('img')(({ theme }) => ({
  width: THUMBNAIL_SIZE,
  height: THUMBNAIL_SIZE,
  objectFit: 'cover',
  borderRadius: theme.shape.borderRadius,
  cursor: 'pointer',
  flexShrink: 0,
}));

export const TooltipImage = styled('img')(({ theme }) => ({
  maxWidth: 300,
  maxHeight: 300,
  borderRadius: theme.shape.borderRadius,
}));

export const PlaceholderIcon = styled(ImageIcon)(({ theme }) => ({
  color: theme.palette.grey[400],
  fontSize: 18,
}));

export const CreativeRowLayout = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  paddingTop: theme.spacing(1),
  paddingBottom: theme.spacing(1),
  gap: theme.spacing(1.5),
}));

export const CreativeRowMain = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1.5),
  minWidth: 0,
  flex: 1,
}));

export const CardHeader = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  paddingBottom: theme.spacing(1),
  gap: theme.spacing(1.5),
}));

export const CardHeaderMain = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1.5),
  flex: 1,
}));

export const TypeLabel = styled(Typography)(({ theme }) => ({
  color: theme.palette.primary.main,
  fontWeight: 600,
  textTransform: 'uppercase',
  letterSpacing: 0.4,
}));

export const EmptyStateText = styled(Typography)(({ theme }) => ({
  color: theme.palette.grey[400],
  paddingTop: theme.spacing(1),
  paddingBottom: theme.spacing(1),
}));

export const SectionLabel = styled(Typography)(({ theme }) => ({
  display: 'block',
  marginBottom: theme.spacing(0.5),
}));

export const AdsetsLabel = styled(Typography)(({ theme }) => ({
  display: 'block',
  marginTop: theme.spacing(1.5),
  marginBottom: theme.spacing(0.5),
}));

export const NameCell = styled(Typography)({
  flex: 1,
});

export const TemplateHeaderRow = styled(Box)({
  display: 'flex',
  alignItems: 'center',
});

export const TemplateRow = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  paddingTop: theme.spacing(1),
  paddingBottom: theme.spacing(1),
}));
